import { createFileRoute } from "@tanstack/react-router";
import { requireAuth } from "@/lib/middleware";
import { InvoiceTemplatesSettings } from "@/features/organizations/settings/invoice-templates";
import { Main } from "@/components/layout/main";
import { authClient } from "@/lib/auth";

export const Route = createFileRoute(
  "/_authenticated/_organization/organizations/settings/invoice-templates"
)({
  beforeLoad: async () => {
    await requireAuth();
  },
  component: InvoiceTemplatesPage,
});

function InvoiceTemplatesPage() {
  const { data: activeOrganization, isPending } =
    authClient.useActiveOrganization();

  if (isPending) {
    return (
      <Main>
        <div className="py-8 text-center">
          <p className="text-muted-foreground">Loading organization...</p>
        </div>
      </Main>
    );
  }

  return (
    <Main>
      <InvoiceTemplatesSettings
        organizationId={activeOrganization?.id || ""}
      />
    </Main>
  );
}
